import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { IconNews } from '@tabler/icons-react';
import { capture } from '@tupai/analytics/client';
import TrialBanner from '@/components/trial-banner';
import { useTranslation } from '@tupai/i18n/react';

export const Route = createFileRoute('/_protected/news')({
  component: NewsPage,
});

function NewsPage() {
  const { t } = useTranslation('common');

  // Coming-soon placeholder today — no article list yet, so article_id is
  // never known here. Fires once per mount, not per render (StrictMode).
  const viewedRef = useRef(false);
  useEffect(() => {
    if (viewedRef.current) return;
    viewedRef.current = true;
    capture('news_viewed', {});
  }, []);

  return (
    <div className="flex-1 flex flex-col min-h-0 bg-surface">
      <div className="px-4 pt-5 pb-4">
        <h1 className="font-display text-2xl text-content">{t('newsTitle')}</h1>
      </div>

      <TrialBanner wrapperClassName="px-4 pb-4" />

      <div className="flex-1 flex flex-col items-center justify-center gap-3 px-6 text-center">
        <div className="w-14 h-14 rounded-pill bg-primary/10 flex items-center justify-center">
          <IconNews size={26} stroke={1.75} className="text-primary" />
        </div>
        <h2 className="text-sm font-extrabold text-content">{t('comingSoon')}</h2>
        <p className="text-sm text-muted font-semibold max-w-xs">{t('newsBody')}</p>
      </div>
    </div>
  );
}
